/**
 * 投放计划 API — 列表 + 确认 + 完成。
 * 这是前端唯一有写操作（POST）的 API 模块。
 */
import client from "./client";
import type { DeliveryPlan } from "../types";

/** 投放计划列表查询参数。 */
export interface DeliveryPlanListParams {
  status?: string;
  product_id?: string;
  /** 按公司过滤（admin 跨账户筛选用）。 */
  company_id?: string;
}

/**
 * 获取投放计划列表。
 * GET /api/delivery-plans?status=&product_id=
 */
export async function getDeliveryPlans(
  params?: DeliveryPlanListParams,
): Promise<DeliveryPlan[]> {
  return client.get<unknown, DeliveryPlan[]>("/delivery-plans", { params });
}

/**
 * 确认投放计划（pending_confirm → confirmed）。
 * POST /api/delivery-plans/{id}/confirm
 * 前端唯一写操作之一：纯状态变更，无请求体。
 */
export async function confirmPlan(planId: string): Promise<DeliveryPlan> {
  return client.post<unknown, DeliveryPlan>(`/delivery-plans/${planId}/confirm`);
}

/**
 * 登记投放完成（confirmed → delivered）。
 * POST /api/delivery-plans/{id}/complete
 * 前端唯一写操作之二：携带实际费用/链接/日期。
 */
export interface CompletePlanParams {
  actual_cost?: number;
  delivery_url?: string;
  actual_date?: string;
}

export async function completePlan(
  planId: string,
  params: CompletePlanParams,
): Promise<DeliveryPlan> {
  return client.post<unknown, DeliveryPlan>(
    `/delivery-plans/${planId}/complete`,
    params,
  );
}
